"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SsrStorage = void 0;
class SsrStorage {
    constructor() {
        this.storage = {};
    }
    setItem(key, value) {
        this.storage[key] = value;
    }
    getItem(key) {
        return this.storage[key];
    }
    removeItem(key) {
        delete this.storage[key];
    }
}
exports.SsrStorage = SsrStorage;
//# sourceMappingURL=ssr-storage.js.map